import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiDoctorCasesParamsGet,
  ApiDoctorCasesResponseGet,
} from 'www/vue_components/common/DoctorCases/api/apiDoctorCases.types'

export default {
  async get({ doctorId, page }: ApiDoctorCasesParamsGet) {
    return axiosClient.get<ApiDoctorCasesResponseGet>(`/api/doctor/cases/?doctor_id=${doctorId}&page=${page}`, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
    }).then(({ data }) => data)
  },
}
